module.exports = __webpack_public_path__ + "img/logo-login.9fa57b05.png";